import React from 'react';
import { Link } from 'react-router-dom';

export default function CraneService() {
    return (
        <div className="min-h-screen bg-gray-50 text-gray-800" dir="rtl">

            {/* HERO SECTION */}
            <div className="bg-slate-900 text-white py-20 px-6 text-center shadow-md relative overflow-hidden">
                <div className="relative z-10 max-w-4xl mx-auto">
                    <h1 className="text-4xl md:text-6xl font-bold mb-4 text-yellow-500 tracking-tight">שירותי הנפה ועבודות גובה</h1>
                    <h2 className="text-2xl md:text-3xl font-light mb-6">מנוף עכביש מתקדם </h2>
                    <p className="text-lg md:text-xl text-slate-300 mb-8 max-w-2xl mx-auto">
                        אלום נואטחה בע"מ גאה להציג שירות חדש ללקוחות פרטיים ולקבלנים (B2B).
                        פתרונות הרמה חכמים, התקנת זכוכיות ענק, ועבודות בגובה עם ציוד הקצה המתקדם בעולם.
                    </p>
                    <a href="#contact" className="inline-block bg-yellow-500 hover:bg-yellow-400 text-slate-900 font-bold py-3 px-8 rounded-full text-lg transition-colors shadow-lg">
                        להזמנת מנוף וקבלת הצעת מחיר
                    </a>
                </div>
            </div>

            <div className="max-w-6xl mx-auto px-6 py-16">

                {/* MAIN IMAGE WITH LOGO OVERLAY */}
                <div className="relative w-full mb-12 rounded-2xl overflow-hidden shadow-2xl group border-4 border-white bg-slate-900">
                    {/* Main Crane Image */}
                    <img
                        src="/crane/cmc1500-glass.jpg"
                        alt="מנוף "
                        className="w-full h-auto max-h-[500px] object-contain mx-auto transition-transform duration-700 group-hover:scale-105"
                        onError={(e) => { e.target.src = 'https://via.placeholder.com/1200x600?text=CMC+1500+Crane+Image'; }}
                    />
                    {/* Logo Overlay */}
                    <div className="absolute top-6 right-6 bg-white/90 backdrop-blur-sm p-3 rounded-xl shadow-lg border border-gray-100 flex items-center gap-3">
                        <img src="/assets/logo-circle.png" alt="Alum Nawatha" className="w-16 h-16 object-contain" onError={(e) => { e.target.style.display = 'none'; }} />
                        <div>
                            <h3 className="font-bold text-blue-900 leading-tight">אלום נואטחה<br />בע"מ</h3>
                        </div>
                    </div>
                </div>

                {/* FEATURES GRID */}
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-slate-800 mb-4">יכולות המנוף והציוד הנלווה</h2>
                    <p className="text-slate-600 max-w-2xl mx-auto">מנוף המיני-זחל שלנו מאפשר גישה למקומות צרים וקשים, חוסך זמן יקר, ומונע סיכוני בטיחות מיותרים באתר הבניה.</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">

                    <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 text-center hover:shadow-md transition-shadow relative">
                        <div className="text-5xl mb-4">🏗️</div>
                        <h3 className="font-bold text-xl text-slate-800 mb-2">מיני מנוף (Mini Crane)</h3>
                        <p className="text-slate-600">מנוף זחל קומפקטי המסוגל לעבור דרך דלתות סטנדרטיות ולעבוד בחללים צרים או על משטחים רגישים.</p>
                        <div className="mt-4 inline-block bg-red-600 text-white font-bold px-4 py-1.5 rounded-full text-sm shadow">⬆ גובה עבודה MAX: 9 מטר</div>
                    </div>

                    <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 text-center hover:shadow-md transition-shadow">
                        <div className="text-5xl mb-4">🪝</div>
                        <h3 className="font-bold text-xl text-slate-800 mb-2">כננת הרמה (Winch)</h3>
                        <p className="text-slate-600">הרמת פרופילים, קונסטרוקציות ומשקלים כבדים בדיוק מילימטרי עד לקומות הגבוהות.</p>
                    </div>

                    <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 text-center hover:shadow-md transition-shadow">
                        <div className="mb-4 flex justify-center"><img src="/crane/basket-icon.jpg" alt="סל אדם" className="w-16 h-16 object-contain" /></div>
                        <h3 className="font-bold text-xl text-slate-800 mb-2">סל אדם (Man Basket)</h3>
                        <p className="text-slate-600">סל הרמה בטיחותי ותקני המאפשר לפועלים ומתקינים לבצע עבודות איטום, חיפוי והתקנה בגובה רב.</p>
                        <div className="mt-4 inline-block bg-yellow-500 text-slate-900 font-bold px-4 py-1.5 rounded-full text-sm shadow">⚠️ עומד בתקן בטיחות</div>
                    </div>

                    <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 text-center hover:shadow-md transition-shadow">
                        <div className="text-5xl mb-4">🪟</div>
                        <h3 className="font-bold text-xl text-slate-800 mb-2">וואקום זכוכית (Vacuum)</h3>
                        <p className="text-slate-600">מתקן יניקה מתקדם (ונטוזות) להנפה והתקנה של ויטרינות זכוכית ענקיות ומשקלים כבדים בבפס אפס מאמץ.</p>
                    </div>

                </div>

                {/* COMPANY LOGO BADGE */}
                <div className="flex items-center justify-center gap-4 mb-16 bg-white p-4 rounded-xl shadow-sm border border-slate-100 max-w-md mx-auto">
                    <img src="/assets/logo-circle.png" alt="Alum Nawatha" className="w-14 h-14 object-contain" />
                    <div className="text-right">
                        <h3 className="font-bold text-blue-900 text-lg leading-tight">אלום נואטחה בע"מ</h3>
                        <p className="text-sm text-slate-500">שירותי הנפה מקצועיים </p>
                    </div>
                </div>

                {/* B2B SECTION */}
                <div className="bg-slate-800 text-white rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-10 mb-16 shadow-xl relative overflow-hidden">
                    {/* Subtle logo watermark in background */}
                    <img src="/assets/logo-circle.png" alt="watermark" className="absolute -left-10 -bottom-10 opacity-10 w-96 h-96 blur-sm" />

                    <div className="flex-1 relative z-10">
                        <h2 className="text-3xl font-bold text-yellow-400 mb-4">שירות לקבלנים וחברות (B2B)</h2>
                        <p className="text-lg text-slate-300 mb-6">
                            נתקעתם עם התקנה מורכבת? הזכוכית כבדה מדי להנפה ידנית? אלום נואטחה מציעה שירות השכרת מנוף על בסיס יומי או פרויקטלי, כולל מפעיל מוסמך.
                        </p>
                        <ul className="space-y-3 text-slate-200">
                            <li className="flex items-center gap-2"><span>✔️</span> פתרון אידיאלי למתקיני אלומיניום, זגגים וקבלני שיפוצים.</li>
                            <li className="flex items-center gap-2"><span>✔️</span> חיסכון דרמטי בכוח אדם וזמן התקנה.</li>
                            <li className="flex items-center gap-2"><span>✔️</span> עבודה בטיחותית המונעת פציעות ונזק לחומרים.</li>
                        </ul>
                    </div>

                    {/* Secondary Image with Logo Overlay */}
                    <div className="flex-1 w-full relative h-[300px] rounded-xl overflow-hidden border-2 border-slate-600">
                        <img
                            src="/crane/cmc1500-glass.jpg"
                            alt="הנפת זכוכית עם מנוף"
                            className="object-cover w-full h-full"
                            onError={(e) => { e.target.src = 'https://via.placeholder.com/600x400?text=Glass+Vacuum+Lifting'; }}
                        />
                        {/* Small Logo Overlay */}
                        <div className="absolute bottom-4 right-4 bg-slate-900/80 p-2 rounded-lg backdrop-blur-sm">
                            <img src="/assets/logo-circle.png" alt="Logo" className="w-10 h-10 object-contain" onError={(e) => { e.target.style.display = 'none'; }} />
                        </div>
                    </div>
                </div>

                {/* CONTACT SECTION */}
                <div id="contact" className="bg-yellow-50 border-2 border-yellow-200 rounded-2xl p-8 text-center max-w-3xl mx-auto shadow-sm">
                    <h2 className="text-2xl font-bold text-slate-800 mb-3">מעוניינים לשכור את המנוף?</h2>
                    <p className="text-slate-600 mb-6">צרו איתנו קשר עכשיו לקבלת הצעת מחיר, ייעוץ טכני ותיאום מועד עבודה.</p>
                    <div className="flex flex-col md:flex-row justify-center items-center gap-4">
                        <a href="tel:0524874031" className="flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white font-bold py-3 px-8 rounded-lg text-xl transition-colors w-full md:w-auto justify-center">
                            <span dir="rtl">📞 052-4874031</span>
                        </a>
                        <a href="mailto:majd@alumnawatha.com" className="flex items-center gap-2 bg-white border-2 border-slate-900 text-slate-900 hover:bg-slate-50 font-bold py-3 px-8 rounded-lg text-xl transition-colors w-full md:w-auto justify-center">
                            <span>✉️</span> שלח אימייל
                        </a>
                    </div>
                </div>

            </div>
        </div>
    );
}